import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class MessageService {
  private readonly subject = new Subject();
  sendMessage(message: string) {
    this.subject.next({ text: message });
  }
  getMessage(): any {
    return this.subject.asObservable();
  }
}
